import { useRoutes } from '@/shared/routes';

export const epkReportsRoutes = [
  {
    path: useRoutes.EPK_REPORT_LIST_PATH,
    name: useRoutes.EPK_REPORT_LIST_NAME,
    component: () => import('@/pages/EpkReportList'),
    props: (route: { query: { period?: number } }) => ({
      query: route.query.period ? route.query.period : 1,
    }),
  },
  {
    name: useRoutes.EPK_REPORT_ITEM_NAME,
    path: useRoutes.EPK_REPORT_ITEM_PATH,
    component: () => import('@/pages/ConsolidatedHouseholdDetailed'),
    props: (route: { params: { id?: string } }) => ({
      id: route.params.id ? route.params.id : '',
    }),
  },
];
